$(function () {
    if ($('main').hasClass('service')) {
        gsap.to(".service-main__el-projecting .service-main__el-img-second", {
            yPercent: 30,
            ease: 'linear',
            scrollTrigger: {
                trigger: ".service-main__el-projecting .service-main__el-img-main",
                // start: "top 40%",
                start: "center center",
                end: "bottom top",
                scrub: 1,
            },
        });
        gsap.to(".service-main__el-design .service-main__el-img-second", {
            yPercent: 30,
            ease: 'linear',
            scrollTrigger: {
                trigger: ".service-main__el-design .service-main__el-img-main",
                // start: "top 40%",
                start: "center center",
                end: "bottom top",
                scrub: 1,
            },
        });
        gsap.to(".service-main__el-layout .service-main__el-img-second", {
            yPercent: 30,
            ease: "linear",
            scrollTrigger: {
                trigger: ".service-main__el-layout .service-main__el-img-main",
                // start: "top 40%",
                start: "center center",
                end: "bottom top",
                scrub: 1,
            },
        });
        gsap.to(".service-main__el-seo .service-main__el-img-second", {
            yPercent: 30,
            ease: "linear",
            scrollTrigger: {
                trigger: ".service-main__el-seo .service-main__el-img-main",
                // start: "top 40%",
                start: "center center",
                end: "bottom top",
                scrub: 1,
            },
        });
    }
});